import lottie from 'lottie-web'
import chkjson from './../../../../lottie/checkbox-3.json'
if(document.querySelector('.input-checkbox')){
    const Checkboxes = document.querySelectorAll('.input-checkbox')
    Checkboxes.forEach(chkbox => {
        const elementLotie = chkbox.querySelector('.checkimg')
        const result = chkbox.querySelector('.result')
        const label = chkbox.querySelector('.label')
        const chkAnim =  lottie.loadAnimation({
            container: elementLotie, // the dom element that will contain the animation
            renderer: 'svg',
            loop: false,
            autoplay: false,
            animationData: chkjson
          });
          chkAnim.setSpeed(2)
        let switchEnabled = false
        elementLotie.addEventListener('click', ()=>{
            switchEnabled = !switchEnabled
            if (switchEnabled) {
                chkAnim.playSegments([106,136], true)
                console.log('true')
                result.value = 'si'
                label.classList.add('active')

            } else {
                chkAnim.playSegments([136,106], true)
                console.log('false')
                result.value = 'no'
                label.classList.remove('active')
            }
          })

    });
}